import React from "react";
import { useNavigate } from "react-router-dom";

import { UserData } from "../types/responseTypes";

const favicon_src = `${process.env.PUBLIC_URL}/logos/favicon.svg`;
const only_src = `${process.env.PUBLIC_URL}/logos/only_logo.svg`;

const letter_logo_bh_src = `${process.env.PUBLIC_URL}/logos/letter_logo_bh.svg`; // bh: black letters, horizontal
const letter_logo_wh_src = `${process.env.PUBLIC_URL}/logos/letter_logo_wh.svg`; // wh: white letters, horizontal

export type LogoBackgroundColor = "blue" | "black" | "white";

const backgroundColorMap = {
  blue: "#5A6ED5",
  black: "#30323A",
  white: "#FFFFFF",
};

interface HLetterLogoProps {
  userData: UserData;
  backgroundColor: LogoBackgroundColor; // Only allows "blue", "black", or "white"
  h: string;
}

export const HLetterLogo: React.FC<HLetterLogoProps> = ({ userData, backgroundColor, h }) => {

  const logo_src =
    backgroundColor === "white" ? letter_logo_bh_src : letter_logo_wh_src;

  const navigate = useNavigate();
  const bookingIndex = 0;
  return (
    <div
      className="flex justify-center items-center cursor-pointer"
      style={{
        backgroundColor: backgroundColorMap[backgroundColor],
        margin: h,
      }}
      onClick={() => navigate("/home", { state: { userData, bookingIndex } })}

    >
      <img
        src={logo_src}
        alt="Ruuf Logo"
        style={{
          height: h,
          width: 'auto',
        }}
      />
    </div>
  );
};

interface OnlyLogoProps {
  h: string;
}

export const OnlyLogo: React.FC<OnlyLogoProps> = ({ h }) => (
  <img
    src={only_src}
    alt="Ruuf Logo"
    style={{
      height: h,
      width: 'auto',
    }}
    className="my-4"
  />
);

export const RuufFavicon: React.FC<{ img_src: string }> = () => (
  <img src={favicon_src} alt="Ruuf Favicon" className="w-6 h-6" />
);